import type { SessionData } from '@optionway/models';

export const PARTNER_ID = 'partnerId' satisfies keyof SessionData;
export const DEFAULT_PARTNER_ID = '4727249';
export const isValidPartnerId = (value: unknown): value is string => typeof value === 'string' && /^\d+$/.test(value);
